import React from 'react';
import logo from '../../assets/logo.png';

interface LogoProps {
    className?: string;
    height?: number | string;
}

export const Logo: React.FC<LogoProps & { style?: React.CSSProperties }> = ({ className, height, style }) => {
    return (
        <img
            src={logo}
            alt="Karen Logo"
            className={className}
            style={{ height, objectFit: 'contain', ...style }}
        />
    );
};
